import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { track } from "@/lib/posthog/events";
import { inspectSignatures } from "./signatureInspection";

export function useSignatureInspection(documentId: string) {
  const client = useQueryClient();
  const key = ["document-signature-inspection", documentId];
  const query = useQuery({
    queryKey: key,
    queryFn: () => inspectSignatures(documentId),
    staleTime: 15_000,
    retry: false,
    refetchOnWindowFocus: false,
    refetchInterval: (current) => (current.state.data?.state === "pending" ? 2000 : false),
  });
  const refresh = useMutation({
    mutationFn: () => inspectSignatures(documentId, true),
    onSuccess: (result) => {
      client.setQueryData(key, result);
      track("document_signatures_checked", {
        outcome: result.state,
        signature_count: result.signatures.length,
      });
    },
  });
  return {
    ...query,
    refresh: () => refresh.mutate(),
    isRefreshing: refresh.isPending,
    refreshError: refresh.isError,
  };
}
